const cols = ({ t, activeFilters = {} }) => [
  {
    title: t("Type"),
    dataIndex: "namespace",
    key: "namespace",
    show: true,
  },
  {
    title: t("System ID"),
    dataIndex: "datastakeId",
    key: "datastakeId",
    show: true,
    sorter: () => 0 + 0,
    defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
  },
  {
    title: t("Date of deletion"),
    dataIndex: 'dateOfDeletion',
    key: 'dateOfDeletion',
    show: true,
    sorter: () => 0 + 0,
    defaultSortOrder: activeFilters.sortBy === 'dateOfDeletion' ? activeFilters.sortDir : undefined,
    render: (_, data) => {
      const delStatus = (data.statuses || []).find(d => d.status === 'deleted');

      if (delStatus) {
        return delStatus.date;
      }

      return '-';
    }
  },
  {
    title: t("Reason of deletion"),
    dataIndex: 'deletionReason',
    key: 'deletionReason',
    show: true,
  }
];

export default cols;
